<template>
  <div
      class="cws-container blog-wrapper"
  >

    <div>
      <b-row>
        <b-col
            md="12"
            lg="12"
        >
          <b-card
              title="Kworb-Импорт"
              class="mb-3"
              border-variant="primary"
          >
            <b-card-text>
              Kworb-Импорт
            </b-card-text>

            <b-form-group
                label="Фильтр"
                label-for="siq-file"
            >
              <label>Чарт</label>
              <v-select
                  v-model="url"
                  :options="charts"
                  class="w-100"
                  :reduce="val => val.value"
                  :clearable="false"
              />
            </b-form-group>
          </b-card>
        </b-col>
      </b-row>

    </div>

    <!-- content -->
    <div class="blog-detail-wrapper">
      <b-row  v-if="playlistDetail">
        <!-- blogs -->
        <b-col cols="12">
          <b-overlay
              :show="isLoadingPlaylist"
              rounded="sm"
          >
            <b-card
                _img-top
                _img-alt="Постер"
                _:title="`${playlistDetail.title}`"
            >
              <h1 class="d-flex">{{ playlistDetail.title }}
                <b-button
                    v-if="playlistDetail.url"
                    :href="playlistDetail.url"
                    variant="warning"
                    class="btn-icon ml-1"
                    size="sm"
                >
                  <feather-icon icon="CastIcon"/>
                </b-button>
              </h1>

              <b-row>
                <div
                    class="blog-content"
                    v-html="playlistDetail.description"
                />
              </b-row>

              <b-row>
                <b-col
                    cols="12"
                    md="12"
                    class="d-flex align-items-center justify-content-center mb-2 mb-md-0"
                >


                  <b-card
                      title=""
                      class="col-md-12 col-12"
                  >
                      <b-row>
                        <b-col md="12">
                          <b-tabs
                              pills
                          >
                            <!-- Tab: Песни (таблица) -->
                            <b-tab>
                              <template #title>
                                <feather-icon
                                    icon="Share2Icon"
                                    size="16"
                                    class="mr-0 mr-sm-50"
                                />
                                <span class="d-none d-sm-inline">Песни [{{ playlistDetail.tracks.length }}]</span>
                              </template>

                              <div class="my-1 py-25">
                                <b-table
                                    ref="refTracksListTable"
                                    :items="playlistDetail.tracks"
                                    responsive
                                    :fields="tableColumns"
                                    primary-key="index"
                                    show-empty
                                    empty-text="No tracks"
                                    class="position-relative"
                                >

                                  <!-- Column: Client -->
                                  <template #cell(artists)="data">
                                  <span v-for="artist in data.item.artists">
                                    <b-link
                                        v-if="artist.id"
                                        :to="{ name: 'artist-view', params: { id: artist.id }}"
                                        class="font-weight-bold"
                                    >
                                      {{ artist.name }}
                                    </b-link>
                                    <span                                      v-else>
                                      {{ artist.name }}
                                      <b-button
                                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                          variant="warning"
                                          class="btn-icon ml-1"
                                          size="sm"
                                          @click="addArtist(artist.name)"
                                      >
                                      <feather-icon icon="PlusIcon"/>
                                    </b-button>
                                    </span>
                                    /
                                  </span>
                                  </template>

                                  <!-- Column: duration -->
                                  <template #cell(duration)="data">
                                  <span class="text-nowrap">
                                    {{ formatDuration(data.item.durationMs / 1000) }}
                                  </span>
                                  </template>

                                  <!-- Column: Client -->
                                  <template #cell(actions)="data">
                                  <span class="text-nowrap">
                                    <b-button
                                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                        v-if="!data.item.id"
                                        :variant="(data.item.artists && data.item.artists[0] && data.item.artists[0].id) ? 'success' : 'warning'"
                                        class="btn-icon ml-1"
                                        @click="addTrack(data.item)"
                                    >
                                      <feather-icon icon="PlusIcon"/>
                                    </b-button>
                                  </span>

                                  </template>
                                </b-table>

                              </div>
                            </b-tab>

                          </b-tabs>
                        </b-col>
                      </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-overlay>
        </b-col>
        <!--/ blogs -->
      </b-row>
      <!--/ blogs -->
      <b-row v-else>
        <b-col cols="12">
          <b-overlay
              :show="isLoadingPlaylist"
              rounded="sm"
          >
            <b-card
                title="Данных нет"
                class="col-md-12 col-12"
            >
              <b-card-text>
                Нет данных для отображения.
              </b-card-text>
            </b-card>
          </b-overlay>

        </b-col>
      </b-row>
    </div>
    <!--/ content -->

  </div>
</template>

<script>
import {
  BFormInput,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BImg,
  BLink,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BCard,
  BRow,
  BCol,
  BBadge,
  BCardText,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormTextarea,
  BFormCheckbox,
  BButton,
  BTab,
  BTabs,
  BSpinner,
  BOverlay,
  BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {formatNumber, formatDate, formatDuration} from '@core/utils/filter'
import router from "@/router";
import store from "@/store";
import musicStoreModule from "@/views/db-music/musicStoreModule";
import {onUnmounted, ref, watch} from "@vue/composition-api";
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import TrackRow from "@/views/db-music/TrackRow";
import {count} from "echarts/src/component/dataZoom/history";
import vSelect from "vue-select";

export default {
  components: {
    TrackRow,
    BFormInput,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BBadge,
    BCardText,
    BDropdown,
    BForm,
    BDropdownItem,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    BTab,
    BTabs,
    BSpinner,
    BOverlay,
    BTable,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {}
  },
  methods: {
    count,
  },
  setup() {
    const STORE_MODULE_NAME = 'playlist'
    const toast = useToast()

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, musicStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const playlistDetail = ref(null)
    const isLoadingPlaylist = ref(false)
    const url = ref('spotify/country/global_daily')

    // Table Handlers
    const tableColumns = [
      {key: 'id', label: '#', sortable: false},
      {key: 'artists', sortable: false},
      {key: 'title', sortable: true},
      {key: 'actions'},
    ]

    const charts = [
      { label: 'Spotify Daily Chart - Global', value: 'spotify/country/global_daily' },
      { label: 'Spotify most streamed songs released in 2025', value: 'spotify/songs_2025' },
      { label: 'Spotify most streamed songs released in 2024', value: 'spotify/songs_2024' },
      { label: 'Spotify most streamed songs released in 2023', value: 'spotify/songs_2023' },
      { label: 'Spotify most streamed songs released in 2022', value: 'spotify/songs_2022' },
      { label: 'Spotify most streamed songs released in 2021', value: 'spotify/songs_2021' },
      { label: 'Spotify most streamed songs released in 2020', value: 'spotify/songs_2020' },
      { label: 'Spotify most streamed songs released in 2019', value: 'spotify/songs_2019' },
      { label: 'Spotify most streamed songs released in 2018', value: 'spotify/songs_2018' },
      { label: 'Spotify most streamed songs released in 2017', value: 'spotify/songs_2017' },
      { label: 'Spotify most streamed songs released in 2016', value: 'spotify/songs_2016' },
      { label: 'Spotify most streamed songs released in 2015', value: 'spotify/songs_2015' },
      { label: 'Spotify most streamed songs released in 2014', value: 'spotify/songs_2014' },
      { label: 'Spotify most streamed songs released in 2013', value: 'spotify/songs_2013' },
      { label: 'Spotify most streamed songs released in 2012', value: 'spotify/songs_2012' },
      { label: 'Spotify most streamed songs released in 2011', value: 'spotify/songs_2011' },
      { label: 'Spotify most streamed songs released in 2010', value: 'spotify/songs_2010' },
      { label: 'Shazam Top Songs - Worldwide', value: 'charts/shazam/ww' },
      { label: 'Shazam Top Songs - Russia', value: 'charts/shazam/ru' },
      { label: 'Russia iTunes Top Songs', value: 'charts/itunes/ru' },
      { label: 'Worldwide iTunes Song Chart', value: 'ww/index' },
      { label: 'Worldwide Apple Music Song Chart', value: 'apple_songs/index' },
      { label: 'Deezer Top Songs - Worldwide', value: 'charts/deezer/ww' },
      { label: 'Deezer Top Songs - Russia', value: 'charts/deezer/ru' },
    ]

    const fetchPlaylistData = async () => {
      const res = await store.dispatch('playlist/kworbImport', {url: url.value});
      playlistDetail.value = res.data;
    }

    const addArtist = async (artist) => {
      blockData()
      try {
        await store.dispatch(`playlist/createArtist`, {title: artist})
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error adding artist',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    const addTrack = async (track) => {
      let artist_id = null
      let artist_name = null
      if (track && track.artists && track.artists[0] && track.artists[0].id) {
        artist_id = track.artists[0].id
      }
      if (track && track.artists && track.artists[0] && track.artists[0].name) {
        artist_name = track.artists[0].name
      }

      blockData()

      try {
        if (!artist_id) {
          const response = await store.dispatch(`playlist/createArtist`, {title: artist_name})
          let new_artist_id = response.data.data.id
          await store.dispatch('playlist/addTrack', {id: new_artist_id, queryParams: {title: track.title}})
          refreshData()
        } else {
          await store.dispatch('playlist/addTrack', {id: artist_id, queryParams: {title: track.title}})
          refreshData()
        }
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error adding track',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        unblockData()
      }
    }

    watch([url], () => {
      refreshData()
    }, {
      deep: true,
    })

    const refreshData = () => {
      blockData()
      fetchPlaylistData().catch(error => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching playlist data',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }).finally(() => {
        unblockData()
      })
    }

    const blockData = () => {
      isLoadingPlaylist.value = true
    }

    const unblockData = () => {
      isLoadingPlaylist.value = false
    }

    refreshData()

    return {
      formatDate,
      playlistDetail,
      isLoadingPlaylist,
      refreshData,
      addArtist,
      blockData,
      unblockData,
      tableColumns,
      formatNumber,
      formatDuration,
      addTrack,
      charts,
      url,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-blog.scss';
</style>
